module.exports = {
  template: require('./cities-list-container.pug')()
  controller: require('./cities-list-container.ctrl')
  bindings:
    country: '<'
}
